import React from "react";
import { motion } from "framer-motion";
import "./caseStudies.css";

const CaseStudyCard = ({
  coin,
  result,
  duration,
  strategy,
  achievement,
  delay,
}) => {
  return (
    <motion.div
      className="case-study-card"
      initial={{ opacity: 1, y: 0, scale: 1 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.3, delay }}
      whileHover={{
        y: -8,
        scale: 1.02,
        transition: { duration: 0.2 },
      }}
    >
      <div className="coin-badge">{coin}</div>
      <div className="highlight-result">{result}</div>

      <div className="campaign-type">
        <span className="campaign-label">Duration:</span>
        <span className="campaign-value">{duration}</span>
      </div>

      <div className="influencers-info">
        <span className="info-label">Strategy:</span>
        <span className="info-value">{strategy}</span>
      </div>

      <div className="results-info">
        <span className="info-label">Achievement:</span>
        <span className="info-value">{achievement}</span>
      </div>

      {/* Decorative Gradient Line */}
      <div className="card-gradient-line"></div>
    </motion.div>
  );
};

export default CaseStudyCard;

